import { createStore } from 'vuex'
import getters from './getters'

// Vite's import.meta.glob for auto-loading modules
const modulesFiles = import.meta.glob('./modules/*.js', { eager: true })

// auto require all vuex module from modules file
const modules = Object.keys(modulesFiles).reduce((modules, modulePath) => {
  // set './modules/user.js' => 'user'
  const moduleName = modulePath.replace(/^\.\/modules\/(.*)\.\w+$/, '$1')
  const value = modulesFiles[modulePath]
  modules[moduleName] = value.default
  return modules
}, {})

const store = createStore({
  modules,
  getters
})

export default store
